const DEFAULT_LANGUAGE = 'en-US';

const LANGUAGE_MAP = {
  'en-US': 'en-US',
  en: 'en-US',
  'zh-CN': 'zh-CN',
  zh: 'zh-CN',
  'zh-TW': 'zh-TW',
  'vi-VN': 'vi-VN',
  vi: 'vi-VN',
  'id-ID': 'id-ID',
  id: 'id-ID',
  'ms-MY': 'ms-MY',
  ms: 'ms-MY',
  'th-TH': 'th-TH',
  th: 'th-TH',
};

let currentLanguage = DEFAULT_LANGUAGE;

try {
  localStorage.removeItem('appLanguage');
} catch (e) {
  // ignore
}

export { DEFAULT_LANGUAGE };

export function normalizeLanguage(language, fallback = DEFAULT_LANGUAGE) {
  if (!language || typeof language !== 'string') return fallback;
  return LANGUAGE_MAP[language.trim()] || fallback;
}

export function setRequestLanguage(language) {
  currentLanguage = normalizeLanguage(language);
  return currentLanguage;
}

export function getRequestLanguage() {
  return currentLanguage;
}
